import WalletInfoBlock from './WalletInfoBlock';

export default WalletInfoBlock;
